import ShowLess from "../../partials/ShowLess";
import Markdown from "../../partials/Markdown";

export default () => (
  <ShowLess>
    <div className="content">
      <Markdown
        link="https://raw.githubusercontent.com/nutonomy/nuscenes-devkit/master/docs/"
        path="schema_nuscenes.md"
        asSubPage={true}
      />
    </div>
  </ShowLess>
);
